//member basic operations
import { API } from '../../../backend';
import { objectToQueryString } from '../../../lib/utils';


export const getMembershipPlan = (userId, token,membershipplanId) => {
    return fetch(`${API}/membership-plans/${userId}/${membershipplanId}`, {
        method: 'GET',
        headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const createMembershipPlan = (userId, token, membershipplan) => {

    return fetch(`${API}/membership-plan/${userId}`, {
        method: 'POST',
        headers: {
            'Content-type': "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(membershipplan)
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })

};

export const updateMembershipPlan = (userId, token,membershipplanId, membershipplan) => {
    return fetch(`${API}/update/membership-plan/${userId}/${membershipplanId}`, {
        method: "PUT",
        headers: {
            'Content-type': "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(membershipplan)
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const deleteMembershipPlans = (userId, token, body) => {
    return fetch(`${API}/delete/membership-plans/${userId}`, {
        method: "POST",
        headers: {
            'Content-type': "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
} 


export const blockUnBlockMembershipPlans = (userId, token, membershipplan) => {
    return fetch(`${API}/block-unblock/membership-plans/${userId}`, {
        method: 'POST',
        headers: {
            'Content-type': "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(membershipplan)
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })

};

// body: { membership_plan_ids: [...], isPublished: true|false }
export const publishUnpublishMembershipPlans = (userId, token, body) => {
    return fetch(`${API}/publish-unpublish/membership-plans/${userId}`, {
        method: 'POST',
        headers: {
            'Content-type': "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })

};


export const getMembershipPlans = (userId, token, query) => {
    let str = objectToQueryString(query);
    return fetch(`${API}/membership-plans/${userId}?${str}`, {
        method: 'get',
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getMembershipPlanCount = (userId, token, query) => {
    let str = objectToQueryString(query);
    return fetch(`${API}/membership-plans/count/${userId}?${str}`, {
        method: 'get',
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}